import { ISchema, PaywallComponentProps } from '../../@types'

// Variant D — highlight discount + timer, no CTA button.
export default (schema: ISchema): ISchema => ({
	...schema,
	overrides: {
		...schema.overrides,
		PaywallCountdownQuickAccess: ({ ctx }): PaywallComponentProps.CountdownQuickAccess => ({
			theme: 'discount-timer',
			text: `${ctx.discountPercent}% discount reserved for`,
			buttonEvent: 'scrollToPlanPicker',
		}),
	},
})
